(function () {
    'use strict';

    angular.module('app').controller('ImportRatesCsvController', ImportRatesCsvController);

    ImportRatesCsvController.$inject = ['$timeout', '$uibModalInstance', '$filter', 'serviceProfile', 'tableHeaders', 'Carrier', 'toastr', '$uibModal', 'importOptions'];

    function ImportRatesCsvController($timeout, $uibModalInstance, $filter, serviceProfile, tableHeaders, Carrier, toastr, $uibModal, importOptions) {
        let vm = this;
        let headers = {};
        tableHeaders.map(header => {
            if (header.value.toLowerCase() === 'byweight') {
                headers.weightBased = header.tableHeaders;
            }
            if (header.value.toLowerCase() === 'bypallet') {
                headers.itemBased = header.tableHeaders;
            }
            if (header.value.toLowerCase() === 'bydistance') {
                headers.distanceBased = header.tableHeaders;
            }
            if (header.value.toLowerCase() === 'bytime') {
                headers.timeBased = header.tableHeaders;
            }
            if (header.value.toLowerCase() === 'byvolume') {
                headers.timeBased = header.tableHeaders;
            }
        });
        vm.file = null;
        vm.importCSV = importCSV;
        vm.dismiss = dismiss;
        vm.isColumnInvalid = isColumnInvalid;
        vm.validateFile = validateFile;
        vm.viewPendingImport = viewPendingImport;
        vm.downloadTemplate = downloadTemplate;
        vm.changeRateType = changeRateType;
        vm.weightBasedLabels = [
            {label:'Zone Origin', filterName: 'zoneFrom', sampleVal: 'ADL'},
            {label:'Zone Destination', filterName: 'zoneTo', sampleVal: 'ABY'},
            {label:'Transit Time Earliest Hours', filterName: 'transitTimeEarliestHours', sampleVal: '0'},
            {label:'Transit Time Earliest Days', filterName: 'transitTimeEarliestDays', sampleVal: '1'},
            {label:'Transit Time Earliest Weeks', filterName: 'transitTimeEarliestWeeks', sampleVal: '0'},
            {label:'Transit Time Latest Hours', filterName: 'transitTimeLatestHours', sampleVal: '0'},
            {label:'Transit Time Latest Days', filterName: 'transitTimeLatestDays', sampleVal: '2'},
            {label:'Transit Time Latest Weeks', filterName: 'transitTimeLatestWeeks', sampleVal: '0'}
        ];

        vm.itemBasedLabels = [
            ...angular.copy(vm.weightBasedLabels),
            {label:'Package Type', filterName: 'packagetype', sampleVal: 'byPallet'}
        ];

        vm.distanceBasedLabels = [
            ...angular.copy(vm.weightBasedLabels),
            {label:'Package Type', filterName: 'packagetype', sampleVal: 'byDistance'}
        ];
        vm.timeBasedLabels = [
            ...angular.copy(vm.weightBasedLabels),
            {label:'Package Type', filterName: 'packagetype', sampleVal: 'byTime'}
        ];
        vm.volumeBasedLabels = [
            ...angular.copy(vm.weightBasedLabels),
            {label:'Basic', filterName: 'basic', sampleVal: '0'},
            {label:'Minimum', filterName: 'minimum', sampleVal: '0'},
            {label:'Per Volume Rate', filterName: 'perVolumeRate', sampleVal: '0'},
            {label:'Round Decimal To Nearest Volume', filterName: 'roundDecimalToNearestVolume', sampleVal: '0'},
            {label:'Measure Unit', filterName: 'measureUnit', sampleVal: 'CM'},
            {label:'Volume Offset', filterName: 'volumeOffset', sampleVal: '0'},
            {label:'Reciprocal', filterName: 'reciprocal', sampleVal: 'false'}
        ];
        vm.weightBasedValues = vm.weightBasedLabels.map((label, index)=>{
            return {name: `Column ${index + 1}`, value: index + 1}
        });
        vm.volumeBasedValues = vm.volumeBasedLabels.map((label, index)=>{
            return {name: `Column ${index + 1}`, value: index + 1}
        });
        vm.itemBasedValues = [
            ...angular.copy(vm.weightBasedValues),
            {name: `Column ${vm.weightBasedValues.length + 1}`, value: vm.weightBasedValues.length + 1}
        ];
        vm.distanceBasedValues = [
            ...angular.copy(vm.weightBasedValues),
            {name: `Column ${vm.weightBasedValues.length + 1}`, value: vm.weightBasedValues.length + 1}
        ];
        vm.timeBasedValues = [
            ...angular.copy(vm.weightBasedValues),
            {name: `Column ${vm.weightBasedValues.length + 1}`, value: vm.weightBasedValues.length + 1}
        ];
       
        init();

        function init() {
            angular.forEach(headers,(val, key)=>{
                const startingIndex = vm[key + 'Labels'].length + 1;
                if(val){
                    vm[key + 'Labels'] = vm[key + 'Labels'].concat(angular.copy(val).map(label=>{
                        if(label.filterName === 'allowedReciprocal'){
                            label.filterName = 'reciprocal';
                            return angular.extend(label, {sampleVal: true});
                        }
                        return angular.extend(label, {sampleVal: 0})
                    }));
                    angular.forEach(val, (header,i)=>{
                        let tmp = {name: 'Column ' + parseInt(i + startingIndex), value: parseInt(i + startingIndex)};
                        vm[key + 'Values'].push(tmp);
                    })
                }
            });

            vm.importTypes = serviceProfile.service.rateCategories.map(rateType=>{
                return rateType
            });
            vm.label = vm.importTypes.find(type=>type.value === angular.getObjVal(importOptions, 'rateType.value'));
            vm.importTypesRaw = angular.copy(vm.importTypes);
            getColumnsFormat(angular.getObjVal(importOptions, 'rateType.value'));
            checkForDraft();
        }

        function getColumnsFormat(type){
           const baseLabels = [];
            Carrier.rateColumnsTemplate(type,res=>{
                const labels = Object.keys(res)
                for(let i in labels){
                    baseLabels.push({
                        label: res[labels[i]], filterName: labels[i]
                    })
                }
                const baseValues = baseLabels.map((label, index)=>{
                    return {name: `Column ${index + 1}`, value: index + 1}
                });
                
                vm.importType =  {
                            label: vm.label.name,
                            value: type,
                            columnValues: baseValues,
                            columnLabels: baseLabels,
                            columns: [...baseValues.map((val, index)=>{
                                return {
                                    value: angular.extend(angular.copy(val), {
                                        label: baseLabels[index]
                                    })
                                };
                            })]
                        }
                vm.importTypeRaw = angular.copy(vm.importType);
            },
            err=>{

            })
        }

        function checkForDraft() {
            vm.draftSearching = true;
            Carrier.getServiceRateCards(serviceProfile.id, data=>{
                vm.hasDraft = !!angular.getObjVal(data, 'content.length');
                vm.draftSearching = false;
            },error=>{
                toastr.error('Unable to search for draft imports', error.message);
                vm.draftSearching = false;
            }, {size:1, draft: true})
        }
        /**
         * Import the csv file
         */
        function importCSV(form, rateType) {
            getMappedFields();
            form.$setSubmitted();
            if(form.$invalid){
                vm.isImporting = false;
                return false;
            }
            
            vm.isImporting = true;
            if(vm.file){
                vm.progressData = 0;
                $timeout(() => {
                    vm.progressData = 50;
                    if(rateType.value === 'byweight'){
                        Carrier.importWeightRateCards(serviceProfile.id, data=>{
                            vm.progressData = 100;
                            toastr.success('CSV successfully imported!');
                            vm.isImporting = false;
                            dismiss();
                        }, err =>{
                            vm.isImporting = false;
                            toastr.error('CSV import failed!', err.message);
                        }, vm.file, {columns: getMappedFields()});
                    }
                    if(rateType.value === 'byvolume'){
                        Carrier.importVolumeRateCards(serviceProfile.id, data=>{
                            console.log(data)
                            vm.progressData = 100;
                            toastr.success('CSV successfully imported!');
                            vm.isImporting = false;
                            dismiss();
                        }, err =>{
                            vm.isImporting = false;
                            toastr.error('CSV import failed!', err.message);
                        }, vm.file, {columns: getMappedFields()});
                    }
                    if(rateType.value === 'bypallet'){
                        Carrier.importItemRateCards(serviceProfile.id, data=>{
                            vm.progressData = 100;
                            toastr.success('CSV successfully imported!');
                            vm.isImporting = false;
                            dismiss();
                        }, err =>{
                            vm.isImporting = false;
                            toastr.error('CSV import failed!', err.message);
                        }, vm.file, {columns: getMappedFields()});
                    }
                    if(rateType.value === 'bytime'){
                        Carrier.importTimeRateCards(serviceProfile.id, data=>{
                            vm.progressData = 100;
                            toastr.success('CSV successfully imported!');
                            vm.isImporting = false;
                            dismiss();
                        }, err =>{
                            vm.isImporting = false;
                            toastr.error('CSV import failed!', err.message);
                        }, vm.file, {columns: getMappedFields()});
                    }
                    if(rateType.value === 'byvolume'){
                        Carrier.importVolumeRateCards(serviceProfile.id, data=>{
                            console.log(data)
                            vm.progressData = 100;
                            toastr.success('CSV successfully imported!');
                            vm.isImporting = false;
                            dismiss();
                        }, err =>{
                            vm.isImporting = false;
                            toastr.error('CSV import failed!', err.message);
                        }, vm.file, {columns: getMappedFields()});
                    }
                    /*
                    *
                    * ADD CONDITION FOR THE DISTANCE BASED RATES IMPORT
                    *
                    * */
                }, 100);
            }
        }
        function getOrderedColByField(field) {
            return vm.importType.columns.map(column=>{
                return vm.importTypeRaw.columns[column.value.value - 1].value.label[field];
            });
        }

        function getRateTemplate(columns){
            let fileName = null;
            const rateType = angular.getObjVal(importOptions, 'rateType.value')
            const payload = {
                rateType:rateType,
                columns:columns
            }
            
            if(rateType === 'byweight'){
                fileName="weight-based-rate-import.csv";
            }
            if(rateType === 'bypallet'){
                fileName="item-based-rate-import.csv";
            }
            if(rateType === 'bydistance'){
                fileName="distance-based-rate-import.csv";
            }
            if(rateType === 'bytime') {
                fileName = "time-based-rate-import.csv";
            }
            if(rateType === 'byvolume') {
                fileName = "volume-based-rate-import.csv";
            }

            Carrier.rateTemplate(payload,res=>{
                download(res, fileName, "text/csv");
            },
            err=>{
                console.log(err)
            });
        }

      

        function getMappedFields() {
            return getOrderedColByField('filterName').toString();
        }
        function getMappedValues() {
            return getOrderedColByField('sampleVal').toString()
        }
        function viewPendingImport() {
            var modalInstance = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                windowClass: 'full-height-modal',
                templateUrl: '/templates/pages/carriers/additionals/pendingImportsModal.html',
                controller: 'PendingImportModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    param: function () {
                        return {
                            serviceProfile: angular.copy(serviceProfile)
                        };
                    },
                    importService: function () {
                        //return Carrier.confirmImportAPI
                    }
                }
            });
            modalInstance.result.then(function (data) {
                checkForDraft();
            }, function () {
                checkForDraft();
            });
        }
        function validateFile(file) {
            return file.type === 'text/csv' || file.type === 'application/vnd.ms-excel' || file.type === 'application/octet-stream';
        }
        /**
         * Closed the modal
         */
        function dismiss() {
            $uibModalInstance.dismiss();
        }

        /**
         * Check if the column is not yet selected
         * if the column is already selected
         *
         * @param {object } column
         */
        function isColumnInvalid(importType, column) {
            if (!column) {
                return false;
            }
            return importType.columns.filter(col => {
                return column.value.value=== col.value.value;
            }).length > 1;
        }

        function downloadTemplate() {
            const field = getMappedFields()
            getRateTemplate(field)
        }

        function changeRateType(selected) {
            
            vm.importTypes = angular.copy(vm.importTypesRaw);
            vm.importTypeRaw = angular.copy(selected);

            getColumnsFormat(selected.value)
        }
    }

})();



// WEBPACK FOOTER //
// ./js/controllers/carriers/ImportRatesCsvController.js